import { render, staticRenderFns } from "./CollaboratorsDetails.vue?vue&type=template&id=77e6f663&"
import script from "./CollaboratorsDetails.vue?vue&type=script&lang=js&"
export * from "./CollaboratorsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports